<template>
  <!-- ==============================================
  **Footer opt1**
  ===================================================-->
  <footer class="footer d-print-none">
    <div class="container-custom bottom">
      <div class="row footer-sec d-flex">
            <div class="col-md-3 col-4 col-sm-4">
                <div class="quick-links">
                  <p class=" mb-2">VERTICALS</p>
                  <ul class="d-inline">
                    <!-- <li>
                      <router-link :to="{ name: 'dance-school' }" class="" target="_blank">Dance School</router-link>
                    </li>
                    <li>
                      <router-link :to="{ name: 'corporate-training' }" class="" target="_blank">Corporate & Professional Training  </router-link>
                    </li>
                    <li>
                      <router-link :to="{ name: 'learning-academies' }" class="" target="_blank">Language & Learning Center</router-link>
                    </li>
                    <li>
                      <router-link :to="{ name: 'fitness-sports' }" class="" target="_blank">Fitness & Sports Training Center</router-link>
                    </li> -->

                    <li>
                      <a href="https://circleram.ai/verticals/dance" target="_blank">Dance School</a>
                    </li>
                    <li>
                      <a href="https://circleram.ai/verticals/corporate" target="_blank">Corporate & Professional Training</a>
                    </li>
                    <li>
                      <a href="https://circleram.ai/verticals/learning" target="_blank">Language & Learning Center</a>
                    </li>
                    <li>
                      <a href="https://circleram.ai/verticals/fitness" target="_blank">Fitness & Sports Training Center</a>
                    </li>
                    
                  </ul>
                </div>
            </div>
            <div class="col-md-3 col-4 col-sm-4">
              <div class="quick-links">
                <p class="text-light mb-2">SITE MAP</p>
                <ul class="d-block">

                  <li>
                    <a href="https://circleram.ai" id="lnkFooterHome">Home</a>
                  </li>
                  <!-- <li>
                    <a href="https://cm.circleram.com/home.aspx" id="lnkFooterLearn">Learn</a>
                  </li> -->
                  <li>
                    <a href="https://circleram.com/aboutus.aspx" id="lnkFooterAboutUs">About Us</a>
                  </li>
                  <li>
                    <a href="https://circleram.com/privacy.aspx" id="lnkFooterPrivacy">Privacy Policy</a>
                  </li>
                  <li>
                    <a href="https://circleram.com/refund.aspx" id="lnkFooterRefund">Refund Policy</a>
                  </li>
                  <li>
                    <a href="https://circleram.com/terms.aspx" id="lnkFooterTerms">Term of Service</a>
                  </li>
                  <li>
                    <a href="https://cm.circleram.com/support/blog" id="lnkFooterBlog">Blog</a>
                  </li>
                  <li>
                      <router-link class="" :to="{ name: 'accessibility' }"
                        >Accessibility</router-link>
                    </li>
                </ul>
              </div>
            </div>

            <div class="col-md-3 col-4 col-sm-4">
              <div class="quick-links">
                <p class=" mb-2">SOCIAL MEDIA</p>
                <ul class="d-inline">
                  <li>
                    <span class="mr-1"> <img style="height: 16px;" src="/assets/images/icon/twitter.svg " alt=""></span> <a href="https://x.com/Circleram2" target="_blank" id="lnkFooterRefund">Twitter</a>
                  </li>
                  <li>
                    <span class="mr-1"> <img style="height: 16px;" src="/assets/images/icon/linkedin.svg " alt=""></span> <a href="https://www.linkedin.com/company/circleram/about/" target="_blank" id="lnkFooterRefund">LinkedIn</a> 	
                  </li>
                  <li>
                    <span class="mr-1"> <img style="height: 16px;" src="/assets/images/icon/facebook.svg " alt=""></span> <a href="https://www.facebook.com/circleram2" target="_blank" id="lnkFooterRefund">Facebook</a>
                  </li>
                  <li>
                    <span class="mr-1"> <img style="height: 16px;" src="/assets/images/icon/youtube.svg " alt=""></span> <a href="https://www.youtube.com/channel/UCSyBtSk3P0c_rpi_hHRMl1A" target="_blank" id="lnkFooterRefund">YouTube</a>
                  </li>
                  <li>
                    <span class="mr-1"> <img style="height: 16px;" src="/assets/images/icon/instagram.svg " alt=""></span> <a href="https://www.instagram.com/circleram2" target="_blank" id="lnkFooterRefund">Instagram</a>
                  </li>
                </ul>
              </div>
            </div>
            
        <div class="col-md-3 col-12 col-sm-12">
          <div class="quick-links">
            <p class=" mb-2">CONTACT US</p>
            <ul class="d-inline">
              <li class="">
                <a href="mailto:learn@circleram.com">Sales: learn@circleram.com</a> <br>
                <a href="mailto:support@circleram.com">Support: support@circleram.com</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 col-6 mob-acco text-light footer-logo">
              <a href="/home"><img :src="`${baseURL}/assets/images/CM-Logo-white.png`" class="img-fluid mt-2 mb-2" alt=""
                style="height: 60px;" /></a>
              <div class="w-100 mt-2 mb-2">
                <span id="siteseal"></span>
              </div>
              <span> Copyright © {{ this.date }} Circleram. All Rights Reserved.</span>
        </div>
        <div class="col-sm-12 col-6 d-flex justify-content-end align-items-end">
          <div class="text-light">
            Powered by: <a href="https://circleram.ai/" target="_blank" class="text-warning">CircleRAM</a>
          </div>
        </div>
      </div>

      <div class="row justify-content-end d-none">
        <div class="col-12 d-flex justify-content-end">
          <div class="text-light">
            Powered by: <a href="https://circleram.ai/" target="_blank" class="text-warning">CircleRAM</a>
          </div>
        </div>
      </div>

    </div>
  </footer>
</template>

<script>

export default {
  name: 'Footer',
  data() {
    return {
      baseURL: process.env.VUE_APP_BASE_URL,
      date: new Date().getFullYear(),
      supportURL: process.env.VUE_APP_SUPPORT_BASE_URL
    }
  },
  mounted() {
    let starfieldtechScript = document.createElement('script')
    starfieldtechScript.setAttribute('src', 'https://seal.starfieldtech.com/getSeal?sealID=HaarvVeYc7boSNbd0cOQIraekT151LSQtZasEiJadaLNpFs9x6SB3DjIm9kk')
    document.head.appendChild(starfieldtechScript)
  }
}
</script>
